import { Base } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export class Api extends Base {
  async saveRawBroilerBatches(jsonParsedData) {
    const response = await this.api().put(`v1/dataAdmin/raw-broiler-batches`, jsonParsedData);
    return this.handleResponse(response);
  }

  async saveRawLayerBatches(jsonParsedData) {
    const response = await this.api().put(`v1/dataAdmin/raw-layer-batches`, jsonParsedData);
    return this.handleResponse(response);
  }
}

export const DataAdminAPI = new Api();



// WEBPACK FOOTER //
// ./src/dataAdmin/api.js